<template>
  <span>
    <strong>Note</strong>:
    Devices running macOS 11.0+ (Big Sur) must be enrolled in JumpCloud
    MDM to be managed by JumpCloud’s Mac
    {{ componentData }}.
  </span>
</template>

<script>
export default {
  name: 'InstructionTextConfigureAppleMDM',
  props: {
    componentData: {
      required: true,
      type: String,
    },
  },
};
</script>
